<ng-container *ngIf="{
    row: columnData | async
  } as $">
<div class="flex align-items-center">
    <span>{{memberSince($.row.client_since).exact}}</span>
    <span class="ml-3"><member-crown [columnData]="columnData"></member-crown></span>
  </div>
  </ng-container>
